export const UPLOAD_URL = '/ads/roi-hub/upload-file';
export const SETUP_EMAIL_INGESTOR_URL = '/ads/roi-hub/setup-email-ingestor';
